const rawBase = import.meta.env.BASE_URL;

export const basePath: string = rawBase.replace(/\/$/, '') || '';
